import React from 'react';
import { Grid, TextField, MenuItem, Card, CardContent, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function PersonalInformation({ formData, handleFormDataChange, setValue }) {
    const handlePersonalChange = (field) => (event) => {
        handleFormDataChange('personal', {
            ...formData.personal,
            [field]: event.target.value,
        });
    };

    const handleEmergencyChange = (field) => (event) => {
        handleFormDataChange('emergency_contact', {
            ...formData.emergency_contact,
            [field]: event.target.value,
        });
    };
    const handleNext = () => {
        setValue('Document');
    };

    return (
        <>
            <Card sx={{ margin: 2 }}>
                <CardContent>
                    <Typography color="#1976d2" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                        <strong style={{ fontWeight: 600 }}>Personal Information</strong>
                    </Typography>
                    <Grid container spacing={5.5}>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Date of Birth (as per certificate)"
                                type="date"
                                name="dob_in_cert"
                                value={formData.personal?.dob_in_cert || ''}
                                onChange={handlePersonalChange('dob_in_cert')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                    "& .MuiInputBase-input": {
                                        color: formData.personal?.dob_in_cert ? "#000" : "#a2a2a2", // Black when input is given, Gray otherwise
                                    },
                                    "& input::-webkit-datetime-edit-text": {
                                        color: "#a2a2a2", // Ensures placeholder ("dd-mm-yyyy") is gray
                                    },
                                    "& input::-webkit-datetime-edit-year-field, \
                                       & input::-webkit-datetime-edit-month-field, \
                                       & input::-webkit-datetime-edit-day-field": {
                                        color: formData.personal?.dob_in_cert ? "#000" : "#a2a2a2", // Black when selected, Gray when empty
                                    },
                                    "& .MuiFormLabel-asterisk": {
                                        color: "red", // Ensures red color for required asterisk (*)
                                    },
                                }}
                                onFocus={(e) => e.target.showPicker()}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Original Date of Birth"
                                type="date"
                                name="dob_org"
                                value={formData.personal?.dob_org || ''}
                                onChange={handlePersonalChange('dob_org')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                    "& .MuiInputBase-input": {
                                        color: formData.personal?.dob_org ? "#000" : "#a2a2a2", // Black when input is given, Gray otherwise
                                    },
                                    "& input::-webkit-datetime-edit-text": {
                                        color: "#a2a2a2", // Placeholder ("dd-mm-yyyy") in gray
                                    },
                                    "& input::-webkit-datetime-edit-year-field, \
                                       & input::-webkit-datetime-edit-month-field, \
                                       & input::-webkit-datetime-edit-day-field": {
                                        color: formData.personal?.dob_org ? "#000" : "#a2a2a2", // Black when selected, Gray when empty
                                    },
                                    "& .MuiFormLabel-asterisk": {
                                        color: "red", // Red asterisk for required field
                                    },
                                }}
                                onFocus={(e) => e.target.showPicker()}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Marital Status"
                                name="marital_status"
                                select
                                value={formData.personal?.marital_status || ''}
                                onChange={handlePersonalChange('marital_status')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            >
                                <MenuItem value="Single">Single</MenuItem>
                                <MenuItem value="Married">Married</MenuItem>
                                <MenuItem value="Divorced">Divorced</MenuItem>
                                <MenuItem value="Widowed">Widowed</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Father/Spouse Name"
                                name="father_spouse_name"
                                value={formData.personal?.father_spouse_name || ''}
                                onChange={handlePersonalChange('father_spouse_name')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            />

                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Official Email"
                                name="official_email"
                                type="email"
                                value={formData.personal?.official_email || ''}
                                onChange={handlePersonalChange('official_email')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                // required
                                label="Personal Email"
                                name="personal_email"
                                type="email"
                                value={formData.personal?.personal_email || ''}
                                onChange={handlePersonalChange('personal_email')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                // required
                                label="Alternate Contact Number"
                                name="alt_phone"
                                value={formData.personal?.alt_phone || ''}
                                onChange={handlePersonalChange('alt_phone')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Nationality"
                                name="nationality"
                                value={formData.personal?.nationality || ''}
                                onChange={handlePersonalChange('nationality')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                required
                                label="Blood Group"
                                name="bg"
                                select
                                value={formData.personal?.bg || ''}
                                onChange={handlePersonalChange('bg')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",

                                    '& .MuiFormLabel-asterisk': {
                                        color: 'red',
                                    },
                                }}
                            >
                                <MenuItem value="A+">A+</MenuItem>
                                <MenuItem value="A-">A-</MenuItem>
                                <MenuItem value="B+">B+</MenuItem>
                                <MenuItem value="B-">B-</MenuItem>
                                <MenuItem value="O+">O+</MenuItem>
                                <MenuItem value="O-">O-</MenuItem>
                                <MenuItem value="AB+">AB+</MenuItem>
                                <MenuItem value="AB-">AB-</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <Card sx={{ margin: 2 }}>
                <CardContent>
                    <Typography color="#1976d2" gutterBottom sx={{ fontSize: '20px', marginBottom: '20px' }}>
                        <strong style={{ fontWeight: 600 }}>Emergency Contact</strong>
                    </Typography>
                    <Grid container spacing={5.5}>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                // required
                                label="Name"
                                name="name"
                                value={formData.emergency_contact?.name || ''}
                                onChange={handleEmergencyChange('name')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                // required
                                label="Relation"
                                name="relation"
                                value={formData.emergency_contact?.relation || ''}
                                onChange={handleEmergencyChange('relation')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <TextField
                                // required
                                label="Mobile Number"
                                name="mobile_num"
                                value={formData.emergency_contact?.mobile_num || ''}
                                onChange={handleEmergencyChange('mobile_num')}
                                InputLabelProps={{ shrink: true }}
                                size='small'
                                sx={{
                                    width: "100%",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} lg={12} sx={{ height: "80px", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                            <Stack direction="row" spacing={2}>
                                <Button
                                    variant="contained"
                                    endIcon={<ArrowForwardIcon />}
                                    onClick={handleNext}
                                >
                                    Next
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}

export default PersonalInformation;